export const locale = {
    lang: 'en',
    data: {
      'WIZARD': {
        'TITULO' : 'Management files ',
        'DESCRIPCION': 'Upload your relevant files',
        'SEARCH':'Search',
        'FILTER':'Write the collaborators name that you are looking for',
        'FILTERCT':'Work center(s) ',
        'CLAVE':'Click to copy the url',
        'ALERT':{
            'BTN1':'Yes',
            'BTN2':'No',
            'LABEL01':'You have not added any doctor',
            'LABEL02':'You have not any date ',
            'LABEL03':'Are you sure you wanna do this actions',
        },
  
      
        
        }
    }
    
};
